module.exports = "/static/media/ring-sound.ad47ec32.mp3";